import CitySEOHead from "@/components/feature/CitySEOHead";
import CouncilBluffsHeroSection from "./components/HeroSection";
import CouncilBluffsStickyNav from "./components/StickyNav";
import CouncilBluffsProcessingTimeSection from "./components/ProcessingTimeSection";
import CouncilBluffsServicesSection from "./components/ServicesSection";
import CouncilBluffsLocalAreaSection from "./components/LocalAreaSection";
import CouncilBluffsTestimonialsSection from "./components/TestimonialsSection";
import CouncilBluffsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CouncilBluffsComparisonSection from "./components/ComparisonSection";
import CouncilBluffsMistakesSection from "./components/MistakesSection";
import CouncilBluffsHowItWorksSection from "./components/HowItWorksSection";
import CouncilBluffsFAQSection, { faqs } from "./components/FAQSection";
import CouncilBluffsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CouncilBluffsFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CouncilBluffsPage() {
  return (
    <>
      <CitySEOHead
        city="Council Bluffs"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/council-bluffs"
        title="Emergency Passport Council Bluffs, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Council Bluffs, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Pottawattamie County, the Omaha metro area, and Southwest Iowa residents."
        geoPlacename="Council Bluffs, Iowa"
        geoPosition="41.2619;-95.8608"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        serviceAreaDesc="Emergency and expedited passport services for Council Bluffs and the Omaha metro area. As fast as 24 hours."
      />
      <div className="font-sans">
        <CouncilBluffsHeroSection />
        <CouncilBluffsStickyNav />
        <CouncilBluffsProcessingTimeSection />
        <CouncilBluffsServicesSection />
        <CouncilBluffsLocalAreaSection />
        <CouncilBluffsTestimonialsSection />
        <CouncilBluffsAcceptanceFacilitiesSection />
        <CouncilBluffsComparisonSection />
        <CouncilBluffsMistakesSection />
        <CouncilBluffsHowItWorksSection />
        <CouncilBluffsFAQSection />
        <CouncilBluffsHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/council-bluffs" state="IA" />
        <CouncilBluffsFinalCTA />
      </div>
    </>
  );
}